import { useEffect } from "react";
// import Header from "@/components/Header";

import HomeHero from "./home/HomeHero";
import MarqueeStrip from "./home/MarqueeStrip";
import GuidesSection from "./home/GuidesSection";
import QuoteBand from "./home/QuoteBand";
import CtaFooter from "./home/CtaFooter";
import HowItWorks from "./HowItWorks";
import ClientsSection from "./ClientsSection";
import FeaturedTools from "./FeaturedTools";
import Faq from "./Faq";
import MobileApps from "./MobileApps";
import SaparyaConferenceSection from "./SaparyaConferenceSection";
import ChildrenPaintingAnimation from "./ChildrenPaintingAnimation";
// import ScrollHeadlineSection from "./ScrollHeadlineSection";
// import StudentCards from "./UserProfileCard";
import "./Home.css";

const AnimatedSection = ({ children, delay = 0, variant = "up" }) => (
  <div
    className={`home-scroll-reveal home-reveal-${variant}`}
    style={{ transitionDelay: `${delay}ms` }}
  >
    {children}
  </div>
);

const Home = () => {
  useEffect(() => {
    const elements = Array.from(document.querySelectorAll(".home-scroll-reveal"));
    if (!elements.length) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-background home-shell">
      <HomeHero />
      <MarqueeStrip />

      <AnimatedSection delay={0} variant="up">
        <ClientsSection />
      </AnimatedSection>

      <AnimatedSection delay={0} variant="up">
        <GuidesSection />
      </AnimatedSection>

      <AnimatedSection delay={0} variant="up">
        <FeaturedTools />
      </AnimatedSection>

      <AnimatedSection delay={0} variant="up">
        <ChildrenPaintingAnimation />
      </AnimatedSection>

      <AnimatedSection delay={0} variant="up">
        <MobileApps />
      </AnimatedSection>

      <AnimatedSection delay={0} variant="up">
        <HowItWorks />
      </AnimatedSection>

      <AnimatedSection delay={0} variant="up">
        <QuoteBand />
      </AnimatedSection>

      <AnimatedSection delay={0} variant="up">
        <Faq />
      </AnimatedSection>

      <CtaFooter />
    </div>
  );
};

export default Home;